import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div
      className="Robustand workshop-learn p-100"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <div className="example example-bottom" data-text="Learn">
              <h2>What You’ll Learn</h2>
            </div>
            {/* <h2>
              What You’ll Learn <span></span>
            </h2> */}
            <p>
              In this comprehensive workshop, you'll gain actionable insights
              into creating a robust business plan that sets a solid foundation
              for your entrepreneurial journey. Whether you're just starting out
              or looking to scale, this workshop covers everything from
              identifying market opportunities to crafting effective sales
              strategies.
            </p>
            {/* <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Consult AI Solutions
            </Link> */}
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>The Importance of a Business Plan</h4>
                  <p>
                    Why a business plan is crucial for both service-based and
                    product-based businesses. How it works as a tool securing
                    funding, guiding growth, and navigating challenges
                  </p>
                </div>
                <div className="robust-content">
                  <h4>How to Craft a Business Plan</h4>
                  <p>
                    Learn the structure of a comprehensive business plan,
                    covering everything from executive summaries to financial
                    projections.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Identify and Capitalize on Market Opportunities</h4>
                  <p>
                    Conduct effective market research to identify trends,
                    customer needs, and market gaps. Also learn techniques for
                    competitor analysis and SWOT analysis to gain a competitive
                    edge.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Outline a Scalable and Sustainable Solution</h4>
                  <p>
                    Learn to define your product or service, highlighting its
                    unique value proposition. Ensure your solution is scalable
                    and adaptable to market changes.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Create a Winning Sales & Marketing Strategy</h4>
                  <p>
                    Identify the components of an effective sales and marketing
                    plan, including identifying target customers and crafting a
                    compelling message.Develop a sales strategy that includes
                    direct sales, partnerships, and lead generation.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Building and Managing a Strong Team</h4>
                  <p>
                    Identify critical team roles and responsibilities for your
                    business’s growth. Learn effective hiring strategies and
                    building a positive, scalable company culture.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Financial Management for Business Success</h4>
                  <p>
                    Create realistic financial projections, manage cash flow,
                    and monitor burn rate. Explore funding options, including
                    bootstrapping, equity investment, and loans.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Prepare for a Successful Business Exit</h4>
                  <p>
                    Learn different exit strategies, including acquisitions,
                    mergers, and IPOs. Value the importance of timing your exit
                    for maximum valuation. Review legal, tax, and financial
                    considerations to ensure a smooth transition.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
